// main package assets (transitively base, theming and icons)
import "@ui5/webcomponents/dist/Assets-fetch.js";

// own fiori package assets
import "./generated/json-imports/Themes-fetch.js";
import "./generated/json-imports/i18n-fetch.js";
